import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { CtTopBarButtonsComponent } from '@cloud-twin-v2/ct-top-bar-buttons/ct-top-bar-buttons.component';
import { FrontendSettingsService } from '@cloud-twin-v2/generated/services/frontend-settings.service';
import { GridMapSelectionSyncComponent } from '@cloud-twin-v2/grid-map-selection-sync/grid-map-selection-sync.component';
import { MapLegendItemComponent } from '@cloud-twin-v2/map-legend-configuration/map-legend-item/map-legend-item.component';
import { MapLegendItemsComponent } from '@cloud-twin-v2/map-legend-configuration/map-legend-items/map-legend-items.component';
import { MapLegendListComponent } from '@cloud-twin-v2/map-legend-configuration/map-legend-list/map-legend-list.component';
import { ScenarioItemComponent } from '@cloud-twin-v2/scenarios-configuration/scenario-item/scenario-item.component';
import { ScenariosListComponent } from '@cloud-twin-v2/scenarios-configuration/scenarios-list/scenarios-list.component';
import { ScenariosSelectorComponent } from '@cloud-twin-v2/scenarios-configuration/scenarios-selector/scenarios-selector.component';
import { MasterOperatorModule } from '@cloud-twin/master-operator/master-operator.module';
import { DynamicLayoutModule } from '@common-modules/dynamic-layout/dynamic-layout.module';
import { GenericStoreService } from '@common-modules/dynamic-layout/state/generic/generic-store.service';
import { ReduxStateModule } from '@common-modules/redux/redux-state.module';
import { CommonSharedComponentModule } from '@common-modules/shared-component/common-shared-component.module';
import { CommonSharedModule } from '@common-modules/shared/common-shared.module';
import { MaterialSharedModule } from '@common-modules/shared/material-shared.module';
import { WidgetRegistryService } from '@common-modules/widget-registry/widget-registry';
import { WLMGridModule } from '@common-modules/wlm-grid/wlm-grid.module';
import { WlmMapModule } from '@common-modules/wlm-map/wlm-map.module';
import { TranslateModule } from '@ngx-translate/core';
import { CtMapPageComponent } from './ct-map-page/ct-map-page.component';
import { CtMapRoutingModule } from './ct-map-routing.module';
import { CtMapTooltipComponent } from './ct-map-tooltip/ct-map-tooltip.component';
import { CTLayerItemService } from './services/ct-layer-item.service';
import { CTMapBuilderService } from './services/ct-map-builder.service';
import { CTResultsFormatService } from './services/ct-results-format.service';
import { CTSyncMapGridService } from './services/ct-sync-map-grid.service';
import { CtMapGridContainerWidgetComponent } from './widgets/ct-map-grid-container-widget/ct-map-grid-container-widget.component';
import { CtMapWidgetComponent } from './widgets/ct-map-widget/ct-map-widget.component';

@NgModule({
  declarations: [
    CtMapPageComponent,
    CtMapWidgetComponent,
    CtMapGridContainerWidgetComponent,
    CtMapTooltipComponent,
    ScenariosSelectorComponent,
    CtTopBarButtonsComponent,
    ScenariosListComponent,
    ScenarioItemComponent,
    MapLegendListComponent,
    MapLegendItemsComponent,
    MapLegendItemComponent,
    GridMapSelectionSyncComponent,
  ],
  imports: [
    ReduxStateModule,
    CommonModule,
    CommonSharedModule,
    CommonSharedComponentModule,
    MaterialSharedModule,
    TranslateModule,
    DynamicLayoutModule,
    MasterOperatorModule,
    WlmMapModule.forFeature({
      layerItemServices: [CTLayerItemService],
    }),
    ReduxStateModule.forFeature({
      storeServices: [GenericStoreService],
    }),
    WLMGridModule,
    CtMapRoutingModule,
  ],
  providers: [
    CTLayerItemService,
    CTResultsFormatService,
    CTMapBuilderService,
    CTSyncMapGridService,
    FrontendSettingsService,
  ],
})
export class CtMapModule {
  static injector: Injector;
  constructor(injector: Injector, private _widgetRegistry: WidgetRegistryService) {
    CtMapModule.injector = injector;
    this._widgetRegistry.register([
      {
        name: 'CtMapWidgetComponent',
        widgetClass: CtMapWidgetComponent,
      },
    ]);
  }
}
